export const businessPlanExportsArticle = {
  title: 'Business Plan Generator: PDF & DOCX Export',
  slug: 'business-plan-exports',
  content: `Business Plan Generator: PDF & DOCX Export

Export your plan for sharing with investors or teammates.

1) PDF preview
- Use “Show PDF Preview” to see the layout.
- Toggle the preview off when you’re done.

2) Export PDF
- Click “Export PDF” to generate a downloadable file.
- If a Business Consultant chat is open, the PDF can be shared to that chat.

3) Export DOCX
- Use the DOCX export option to download a Word file.
`,
};
